<template>
    <div>

        <h5>
            ואצאפ
        </h5>


        <br>


        מצב חשבון:

        {{ $store.state.whatsappStatus }}

        <span>

            <i v-if="!$store.state.whatsappStatus"
               class="fa-solid fa-spinner fa-spin"></i>

        </span>



        <br>
        <br>


        <div class="pull-right">


            <button class="btn btn-success"
                    v-show="!$store.state.whatsappStatus.includes('0')"
                    @click="showQrModal">
                <i class="fa-brands fa-whatsapp"></i>
                &nbsp;
                חיבור חשבון

            </button>


            &nbsp;

            <button class="btn btn-danger"
                    v-show="$store.state.whatsappStatus.includes('0')"
                    @click="disconnect">

                ניתוק חשבון

            </button>

        </div>





        <Modal ref="modal"
               title="חיבור ואצאפ"
               :hideFooter="true">

            <template v-slot:body>




                <div v-show="waitingForQr"
                     style="text-align: center;">

                    <br>
                    <br>

                    רק רגע...

                    <br>
                    <br>



                    <i class="fa-solid fa-cog fa-spin"
                       style="font-size:22px"></i>
                    <br>
                    <br>
                    <br>
                    <br>



                </div>



                <div v-show="!waitingForQr && !qr">


                    <div v-if="qrError"
                         style="color:#b82e24;text-align:center;margin-bottom:20px">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                        &nbsp;{{ qrError }}
                    </div>


                    <br>
                    <br>
                    <br>

                    כאן יופיע קוד
                    QR
                    לסריקה באפליקציית
                    Whatsapp
                    בטלפון הנייד.
                    <br>

                    על מנת להמשיך



                    הכינו את המכשיר במצב סריקה ואז לחצו על הכפתור "צור QR".
                    <br>
                    תהליך היצירה אורך כדקה.

                    <br>
                    <br>
                    <br>
                    <br>
                    <br>

                    <button class="btn btn-primary pull-right"
                            @click="getQr">
                        צור QR
                    </button>

                </div>





                <div v-if="qr"
                     v-html="qr">
                </div>



            </template>

        </Modal>



    </div>
</template>
<script>

export default {
    name: 'WhatsappWeb',
    data() {

        this.$root.$on('whatsappConnected', this.whatsappConnected);

        return {
            intervalToReloadQr: null,
            waitingForQr: false,
            qr: null,
            qrError: null,
            phone: this.suggestedPhone,
            qrReloadCount: 0 // added counter for interval runs
        }
    },
    props: ['suggestedPhone'],
    methods: {


        

        whatsappConnected() {
            this.$handlers.whatsappHandler.getStatus();
            clearInterval(this.intervalToReloadQr);
            this.intervalToReloadQr = null; // ensure cleared
            this.qrReloadCount = 0;
            this.$notify({
                type: 'success',
                title: 'הצלחה',
                text: 'החשבון נקשר בהצלחה',

            })
            this.$refs?.modal?.hide();
        },
        showQrModal() {
            this.qr = null;
            this.qrError = null;
            // reset any previous interval/counter when opening modal
            if (this.intervalToReloadQr) {
                clearInterval(this.intervalToReloadQr);
                this.intervalToReloadQr = null;
            }
            this.qrReloadCount = 0;
            this.$refs.modal.show();
        },
        getQr() {
            this.waitingForQr = true;
            this.qrError = null;
            // clear any existing interval before starting a new one
            if (this.intervalToReloadQr) {
                clearInterval(this.intervalToReloadQr);
                this.intervalToReloadQr = null;
            }
            this.qrReloadCount = 0;

            this.$handlers.whatsappHandler.getQr().then(qrFromServer => {
                this.qr = qrFromServer
                this.waitingForQr = false;

                this.intervalToReloadQr = setInterval(async () => {
                    try {
                        const qrFromServer = await this.$handlers.whatsappHandler.getQr();
                        this.qr = qrFromServer;
                    } catch (e) {
                        // ignore fetch errors
                    }

                    this.qrReloadCount++;

                    // if interval ran 3 times, stop and close modal
                    if (this.qrReloadCount >= 3) {
                        clearInterval(this.intervalToReloadQr);
                        this.intervalToReloadQr = null;
                        this.qrReloadCount = 0;
                        this.$refs?.modal?.hide();
                    }
                }, 45 * 1000)
            }).catch(() => {
                // don't leave the user staring at the "רק רגע" spinner forever —
                // surface the failure and let them retry with the "צור QR" button
                this.waitingForQr = false;
                this.qr = null;
                this.qrError = 'יצירת קוד ה-QR נכשלה. בדקו את החיבור ונסו שוב.';
                this.$notify({
                    type: 'error',
                    title: 'שגיאה',
                    text: 'לא הצלחנו ליצור קוד QR. נסו שוב.'
                });
            })
        },
        disconnect() {
            // clear interval when disconnecting
            if (this.intervalToReloadQr) {
                clearInterval(this.intervalToReloadQr);
                this.intervalToReloadQr = null;
            }
            this.qrReloadCount = 0;
            this.$handlers.whatsappHandler.disconnect();
        }
    },


}
</script>